<template>
    <v-layout row wrap>
        <v-flex xs4 offset-xs4>
            <v-card>
                <v-card-text>
                    <v-form ref="form" @submit.prevent="submit">
                        <div class="title mb-3 mt-1">
                            GDS &mdash; Gestão de Demandas e Serviços
                        </div>

                        <label class="form-label text-xs-left">{{
                            $t("label.user")
                        }}</label>
                        <v-text-field
                            v-model="form.username"
                            :rules="validation.login"
                            :validate-on-blur="true"
                        ></v-text-field>

                        <label class="form-label text-xs-left">{{
                            $t("label.password")
                        }}</label>
                        <v-text-field
                            type="password"
                            v-model="form.password"
                            :rules="validation.password"
                            :validate-on-blur="true"
                        ></v-text-field>

                        <v-btn
                            type="submit"
                            color="primary"
                            class="ml-0"
                            :loading="loading"
                            >{{ $t("label.enter") }}</v-btn
                        >
                    </v-form>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<style lang="stylus"></style>

<script>
import validation from "@/helpers/validation";

export default {
    data() {
        return {
            validation,
            loading: false,
            form: {
                username: "",
                password: "",
                recaptchaToken: null
            }
        };
    },
    methods: {
        async submit() {
            if (!this.$refs.form.validate()) return;

            try {
                this.loading = true;
                await this.recaptcha();
                await this.$store.dispatch("login", this.form);
                this.$router.push({ name: "dashboard" });
            } catch (e) {
                this.loading = false;
            }
        },
        async recaptcha() {
            // (optional) Wait until recaptcha has been loaded.
            await this.$recaptchaLoaded();

            // Execute reCAPTCHA with action "login".
            const token = await this.$recaptcha("submit");

            // Do stuff with the received token.
            this.form.recaptchaToken = token;
        }
    },
    mounted() {
        this.$nextTick(async () => {
            await this.recaptcha();
        });
    }
};
</script>



// WEBPACK FOOTER //
// src/components/login/Login.vue